import {
  get,
  post,
  download
} from "../utils/http";

const elevator = {
  list: params => post('/elevator/list', params),
  pagelist: params => post('/elevator/page', params),
  edgelist: params => post('/edge/edge-device/list', params),
  edgePagelist: params => post('/edge/edge-device/page', params), //终端分页
  restartEdge: params => get('/edge/edge-device/controlDevicePower',params),
  sensorlist: params => post('/sensor/list', params),
  add: params => post('/elevator/add', params),
  edit: params => post('/elevator/edit', params),
  delete: params => post('/elevator/delete', params),
  getSiteList: () => get('/site/list'),
  updateSite: (params) => post('/site/update', params),
  addSite: (params) => post('/site/add', params),
  deleteSite: (params) => get('/site/delete', params),
  getElevatorStatics: params => post('/elevator/getElevatorStatics', params),
  addedge: params => post('/edge/edge-device/add', params),
  editedge: params => post('/edge/edge-device/edit', params),
  deleteEdge: params => post('/edge/edge-device/delete', params),
  sitePage: (params) => post('/site/page', params),
}

export default elevator;


// WEBPACK FOOTER //
// ./src/api/elevator.js